import { Spinner } from 'react-bootstrap'

export default function LoadingScreen() {
  return (
    <div
      className={
        'flex flex-col items-center justify-center h-screen w-screen bg-surface-alt'
      }
    >
      <Spinner animation="border" />
    </div>
  )
}
